import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable, Subscription} from 'rxjs';
import {AdminService} from '../admin.service';
import {ComponentCanDeactivate} from '../shared/pending-changes.guard';
import {SharedService} from '../shared/shared.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy, ComponentCanDeactivate {
  currentPassword = '';
  newPassword = '';
  newPasswordConfirmation = '';
  hidePassword = true;
  hideNewPassword = true;
  hideNewPassword2 = true;
  name: string = '';
  email: string = '';
  private loggedInProfileSubscription: Subscription | undefined;

  valueChangeDetected = false;
  valueChangesSubscription: Subscription | undefined;
  @ViewChild('profileForm') profileForm: NgForm | undefined | null;

  constructor(private adminService: AdminService,
              private sharedService: SharedService,
              private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.loggedInProfileSubscription = this.adminService.getProfileAsObservable().subscribe(
      profile => {
        if (profile) {
          this.name = profile.name;
          this.email = profile.email;
          this.newPassword = '';
          this.newPasswordConfirmation = '';
          this.currentPassword = '';

          setTimeout(() => {
            if (this.valueChangesSubscription) {
              this.valueChangesSubscription.unsubscribe();
            }
            this.valueChangeDetected = false;
            this.valueChangesSubscription = this.profileForm?.valueChanges?.subscribe(result => {
              this.valueChangeDetected = true;
            });
          }, 300);
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.loggedInProfileSubscription) {
      this.loggedInProfileSubscription.unsubscribe();
    }
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean | Observable<boolean> {
    const shouldSave = this.valueChangeDetected && this.profileForm?.valid;
    return !shouldSave;
  }

  save() {
    this.sharedService.showLoadingOverlay();
    this.adminService.updateProfile(this.name, this.currentPassword, this.newPassword).subscribe(_ => {
        this.newPassword = '';
        this.newPasswordConfirmation = '';
        this.currentPassword = '';
        this.valueChangeDetected = false;
        this.sharedService.hideLoadingOverlay();
        this.snackBar.open('Changes saved.', '',
          {
            duration: 2000,
            verticalPosition: 'top',
            panelClass: 'success-snackbar'
          });
      },
      error => {
        this.sharedService.hideLoadingOverlay();
        this.snackBar.open('Failed to save your changes.', '',
          {
            duration: 2000,
            verticalPosition: 'top',
            panelClass: 'error-snackbar'
          });
      });
  }
}
